module.exports = __webpack_public_path__ + "img/music_027.326544ac.png";